import { NavLink, Outlet } from "react-router-dom";
import {
  ChevronRight,
  Database,
  Layers3,
  PlugZap,
  Settings2,
  ShieldCheck,
  UsersRound,
} from "lucide-react";

const settingsGroups = [
  {
    label: "Workspace",
    items: [
      {
        label: "Manage users",
        description: "People, teams and access",
        pathname: "/settings/users",
        icon: UsersRound,
      },
      {
        label: "Role management",
        description: "Roles and permissions",
        pathname: "/settings/roleManagement",
        icon: ShieldCheck,
      },
    ],
  },
  {
    label: "Configuration",
    items: [
      {
        label: "Masters",
        description: "Reference data and catalogs",
        pathname: "/settings/masters",
        icon: Database,
      },
      {
        label: "Preferences",
        description: "Forms, templates and numbering",
        pathname: "/settings/preference",
        icon: Layers3,
      },
      {
        label: "Integrations",
        description: "Connect external services",
        pathname: "/settings/integration",
        icon: PlugZap,
      },
    ],
  },
];

export const Settings = () => {
  return (
    <div
      className="row g-0 border rounded bg-light overflow-hidden"
      style={{ minHeight: "calc(100vh - 7rem)" }}
    >
      <aside
        className="col-12 col-lg-3 bg-white border-end p-3 p-lg-4"
        style={{ minWidth: 0 }}
      >
        <div className="d-flex align-items-start gap-2 ">
          <span
            className="d-flex align-items-center mt-1  justify-content-center rounded"
            style={{ width: 38, height: 38, backgroundColor: "#f9f2f6", color: "#7a3a5e" }}
          >
            <Settings2 size={19} />
          </span>
          <div className="d-flex flex-column align-items-start justify-content-start ">
            <p className=" mb-0 fw-medium" style={{ fontSize: '1.475rem' }}>Settings</p>
            <p className="text-muted small mb-4" style={{ fontSize: '0.775rem' }}>
              Configure your CRM, team and connected services.
            </p>
          </div>
        </div>

        <nav aria-label="Settings navigation">
          {settingsGroups.map((group) => (
            <div className="mb-4" key={group.label}>
              <div className=" text-muted fw-medium small mb-2 px-2">
                {group.label}
              </div>
              <div className="d-flex flex-column gap-1">
                {group.items.map((item) => {
                  const Icon = item.icon;
                  return (
                    <NavLink
                      end={item.pathname === "/settings/masters" || item.pathname === "/settings/preference"}
                      key={item.pathname}
                      to={item.pathname}
                      className="text-decoration-none rounded"
                      style={({ isActive }) => ({
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        padding: "10px 12px",
                        color: isActive ? "#5c2a46" : "#475569",
                        backgroundColor: isActive ? "#f9f2f6" : "transparent",
                        border: `1px solid ${isActive ? "#ead8e3" : "transparent"}`,
                      })}
                    >
                      <span
                        className="d-flex align-items-center justify-content-center rounded"
                        style={{ width: 30, height: 30, backgroundColor: "#f1f5f9" }}
                      >
                        <Icon size={16} />
                      </span>
                      <span className="d-flex flex-column flex-grow-1">
                        <span className="small fw-semibold">{item.label}</span>
                        <span className="text-muted" style={{ fontSize: 11 }}>
                          {item.description}
                        </span>
                      </span>
                      <ChevronRight size={15} className="text-muted" />
                    </NavLink>
                  );
                })}
              </div>
            </div>
          ))}
        </nav>

        {/* <div className="border-top pt-3 text-muted small">
          <ShieldCheck size={15} className="me-1" />
          Changes apply to your organization.
        </div> */}
      </aside>

      <main className="col-12 bg-white col-lg-9 p-2 p-md-3 p-lg-4" style={{ minWidth: 0 }}>
        {/* <section className="bg-white rounded h-100 p-2 p-md-3"> */}
        <Outlet />
        {/* </section> */}
      </main>
    </div>
  );
};